// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner--spinner--VZwB-","graphic":"Spinner--graphic--D-BJP","spin":"Spinner--spin--Rlswq"};